const getAllPeopleApiCall = (headersConfigData) => {
    return fetch(
      `${
        process.env.REACT_APP_API_URL
      }/api/Persons/GetAllPeople`,
      {
        headers: headersConfigData(),
      }
    )
}

const getPeopleBySiteIdApiCall = (siteId, headersConfigData) => {
    if (siteId) {
        return fetch(
        `${
            process.env.REACT_APP_API_URL
        }/api/Persons/Get?siteId=${siteId}`,
        {
            headers: headersConfigData(),
        }
        )
    } else {
        return { msg: "All Parameters are required" };
    }
}

const getGroupsBySiteIdApiCall = (siteId, headersConfigData) => {
    if (siteId) {
        return fetch(
        `${
            process.env.REACT_APP_API_URL
        }/api/Groups/Get?siteId=${siteId}`,
        {
            headers: headersConfigData(),
        }
        )
    } else {
        return { msg: "All Parameters are required" };
    }
}

const savePersonApiCall = (siteId, request, headersConfigData) => {
    if (headersConfigData()) {
      return fetch(
        `${
          process.env.REACT_APP_API_URL
        }/api/Persons/Post?siteId=${siteId}`,
        {
          method: "POST",
          headers: headersConfigData(),
          body: JSON.stringify(request),
        }
      )
    } else {
      return { msg: "All Parameters are required" };
    }
}

const getRfidAccessLevelsApiCall = (headersConfigData) => {
    return fetch(
        `${
            process.env.REACT_APP_API_URL
        }/api/RFIDs/GetAllRFIDAccessLevelAsync`,
        {
            headers: headersConfigData(),
        }
    )
}

const editPersonApiCall = (siteId, personId, request, headersConfigData) => {
    if (headersConfigData()) {
      return fetch(
        `${
          process.env.REACT_APP_API_URL
        }/api/Persons/Put?siteId=${siteId}&personId=${personId}`,
        {
          method: "PUT",
          headers: headersConfigData(),
          body: JSON.stringify(request),
        }
      )
    } else {
      return { msg: "All Parameters are required" };
    }
}

const saveRfidApiCall = (siteId, request, headersConfigData) => {
    if (headersConfigData()) {
      return fetch(
        `${
          process.env.REACT_APP_API_URL
        }/api/RFIDs/Post?siteId=${siteId}`,
        {
          method: "POST",
          headers: headersConfigData(),
          body: JSON.stringify(request),
        }
      )
    } else {
      return { msg: "All Parameters are required" };
    }
}

const updateRfidApiCall = (siteId, rfidId, request, headersConfigData) => {
    if (siteId && rfidId && headersConfigData()) {
      return fetch(
        `${
          process.env.REACT_APP_API_URL
        }/api/RFIDs/Put?siteId=${siteId}&rfidId=${rfidId}`,
        {
          method: "PUT",
          headers: headersConfigData(),
          body: JSON.stringify(request),
        }
      )
    } else {
      return { msg: "All Parameters are required" };
    }
}

const getRFIDByTagApiCall = (siteId, tag, headersConfigData) => {
    return fetch(
        `${
            process.env.REACT_APP_API_URL
        }/api/RFIDs/GetByTag?siteId=${siteId}&tag=${tag}`,
        {
            headers: headersConfigData(),
        }
    )
}

const deleteRfidByTagApiCall = (siteId, tag, headersConfigData) => {
    if (siteId && tag && headersConfigData()) {
      return fetch(
        `${
          process.env.REACT_APP_API_URL
        }/api/RFIDs/deleteByTag?siteId=${siteId}&tag=${tag}`,
        {
          method: "DELETE",
          headers: headersConfigData()
        }
      )
    } else {
      return { msg: "All Parameters are required" };
    }
}

const transferRfidApiCall = (siteId, request, headersConfigData) => {
    if (siteId && request && headersConfigData()) {
      return fetch(
        `${
          process.env.REACT_APP_API_URL
        }api/persons/TransferRfid?siteId=${siteId}&prevPersonId=${request.PreviousPerson.PersonId}&personId=${request.Person.PersonId}`,
        {
          method: "PUT",
          headers: headersConfigData(),
          body: JSON.stringify(request)
        }
      )
    } else {
      return { msg: "All Parameters are required" };
    }
}

const assignNewRfidApiCall = (siteId, person, headersConfigData) => {
    if (siteId && person && headersConfigData()) {
      return fetch(
        `${
          process.env.REACT_APP_API_URL
        }api/persons/AssignNewRfidTag?siteId=${siteId}&personId=${person.personId}`,
        {
          method: "PUT",
          headers: headersConfigData(),
          body: JSON.stringify(person)
        }
      )
    } else {
      return { msg: "All Parameters are required" };
    }
}

export const API_CALLS = {
    getAllPeopleApiCall,
    getPeopleBySiteIdApiCall,
    getGroupsBySiteIdApiCall,
    savePersonApiCall,
    getRfidAccessLevelsApiCall,
    editPersonApiCall,
    updateRfidApiCall,
    saveRfidApiCall,
    getRFIDByTagApiCall,
    deleteRfidByTagApiCall,
    transferRfidApiCall,
    assignNewRfidApiCall
};
